import { render, staticRenderFns } from "./PresetsList.vue?vue&type=template&id=2b953d1a&"
import script from "./PresetsList.vue?vue&type=script&lang=ts&"
export * from "./PresetsList.vue?vue&type=script&lang=ts&"
import style0 from "./PresetsList.vue?vue&type=style&index=0&id=2b953d1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports